import React, { Component } from 'react'
import { Input, Card, CardBody, Col, Row, Alert } from 'reactstrap'
import { Link } from 'react-router-dom'
import values from 'mout/object/values'
import shortid from 'shortid'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText';
import chkDisabled from '../../../helpers/users/manageUsers/chkDisabled'
import resetHeirarchy from '../../../helpers/users/manageUsers/resetHeirarchy';

class SelectorCard extends Component {
  state = {
    district: '',
    school: '',
    teacher: '',
    selectedClass: '',
    nextLink: ''
  }


  static SelectInput = ({ children, header, name, value, disabled, selectOption, baseLink, state }) =>
    <Col>
      <h4 className='title'>{header}</h4>
      <Input
        type='select'
        name={name}
        value={value}
        onChange={(e) => selectOption(e, baseLink, state)}
        disabled={disabled}
      >
        {children}
      </Input>
    </Col>

  static DistrictSelect = ({ district, selectOption, baseLink, districts, state }) => {
    const dists = sortByPropText(values(districts), 'name')
    return (
      <Col className='manage-users-select select-district'>
        <SelectorCard.SelectInput
          name='district'
          header='District'
          value={district}
          disabled={false}
          selectOption={selectOption}
          baseLink={baseLink}
          state={state}
        >
          <option value=''></option>
          {dists.map((dist) => <option key={`selectOp${dist.id}`} value={dist.id}>{dist.name}</option>)}
        </SelectorCard.SelectInput>
      </Col>
    )
  }

   SchoolCount = ({school, selectOption, baseLink, schools, district, state, role}) => {
    //let schoolcount  = 0 ;  
    let schs = sortByPropText(values(schools), 'name')
    if (district) {
      schs = schs.filter(sch => sch.district === district)
    }
    let schoolcount  = schs.length;
    return schoolcount; 
  }
  
  
  static SchoolSelect = ({ school, selectOption, baseLink, schools, district, state, role,color }) => {
    let schs = sortByPropText(values(schools), 'name')
    if (district) {
      schs = schs.filter(sch => sch.district === district)
    }
   
    const disabled = role ? chkDisabled(role, state, 'school') : false
      let school_class = '';
       school_class = "no-school";
      
      if (disabled || schs.length > 0) {
      return (
      <Col className='manage-users-select select-school'>
        <SelectorCard.SelectInput
          name='school'
          header='School'
          value={school}
          disabled={disabled}
          selectOption={selectOption}
          baseLink={baseLink}
          state={state}
        >
          <option value=''></option>
          {schs.map(sch => <option key={`selectSch${sch.id}`} value={sch.id}>{sch.name}</option>)}
        </SelectorCard.SelectInput>
      </Col>
    )} else return (
      <Col className={`manage-users-select select-school ${school_class}`}>
        <Alert color="danger">No schools have been added to this district. To continue, <Link to={'/users/manage/schools/'}>click here</Link> to add a school.</Alert>
      </Col>
    )
  }

  static TeacherSelect = ({ teacher,schools, selectOption, state, baseLink, teachers, school, role }) => {
    let schs = sortByPropText(values(schools), 'name')
    let teachs = sortByPropText(values(teachers), 'lastName')
    if (school) {
      teachs = teachs.filter(teach => teach.school === school)
    }
    const disabled = role ? chkDisabled(role, state, 'teacher') : false
    if(schs.length>0){
    if (disabled || teachs.length !== 0) {
      return (
      <Col className='manage-users-select select-teacher'>
        <SelectorCard.SelectInput
          name='teacher'
          header='Teacher'
          value={teacher}
          disabled={disabled}
          selectOption={selectOption}
          baseLink={baseLink}
          state={state}
        >
          <option value=''></option>
          {teachs.map(teach => <option key={`selT${teach.id}`} value={teach.id}>{teach.fullName}</option>)}
        </SelectorCard.SelectInput>
      </Col>
    )} else return (
      <Col className='manage-users-select select-teacher'>
        <Alert color="danger">No teachers have been added to this school. Please add a teacher to continue.</Alert>
      </Col>
    )
  }else {
    return (<div></div>);
  }
}

  // static ClassSelect = ({children, disabled, selectedClass, selectOption, state}) =>
  //   <this.SelectInput
  //     name='selectedClass'
  //     header='Class'
  //     value={selectedClass}
  //     disabled={disabled}
  //     selectOption={selectOption}
  //     state={state}
  //   >
  //     {children}
  //   </this.SelectInput>

  static Nav = ({ back, nextLink }) =>
    <ul className='bottom-nav'>
      <li className='return link'>
        {back ? <span className='active'><Link to={back}>{'< Return'}</Link></span> : <span className='inactive'>{'< Return'}</span>}
      </li>
      <li className='next link'>
        {nextLink ? <span className='active'><Link to={nextLink}>{'Next >'}</Link></span> : <span className='inactive'>{'Next >'}</span>}
      </li>
    </ul>



  ///// Backup of simple ProgressBar /////
  // static ProgressBar = ({ selectorName, state }) => (
  //   <Col xs='1'>
  //     {state[selectorName] ? '|' : 'O'}
  //   </Col>
  // )


  // Example of classname Ternerary



  static ProgressBar = ({ selectorName, state,color }) => (
    <Col className='prog-bar'>
      <div className='org-info-select-prog'>
        <span className={state[selectorName] ? 'outer-circle selected' : 'outer-circle'}>
          <span className="inner-circle " style={{backgroundColor:color}}></span>
        </span>
        <br />
        <span className={state[selectorName] ? 'connecting-line selected' : 'connecting-line'}>
        </span>
      </div>
    </Col>
  )

  static Instructions = ({ children }) =>
    <Col xs='12' className='instructions'><p>{children}</p></Col>

  static Header = ({ children }) =>
    <h4>{children}</h4>

  selectOption = (e, baseLink, state) => {
    let update = { [e.target.name]: e.target.value }
    if (baseLink) {
      update.nextLink = `${baseLink}${e.target.value}`
    }
    update = resetHeirarchy(e.target.name, update, state)
    this.setState(update)
  }

  render() {
    return (
      <Row className='selector-card' noGutters>
        {React.Children.map(this.props.children, child =>
          React.cloneElement(child, {
            district: this.state.district,
            school: this.state.school,
            teacher: this.state.teacher,
            selectedClass: this.state.selectedClass,
            selectOption: this.selectOption,
            state: this.state,
            nextLink: this.state.nextLink,
            // chkDisabled: this.chkDisabled,
          })
        )}
      </Row>
    )
  }
}

export default SelectorCard


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/SelectorCard.js